/**
 * @flow
 */

import React from 'react'
import styled, { css } from 'styled-components'
import { colors, animations } from '../theme'
import { withTenant } from '../../context/tenantConfig'

const Bars = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${props => props.theme.primary || colors.background};
  animation: ${animations.load} 1s infinite ease-in-out;
  width: 1em;
  height: 4em;
  color: ${props => props.theme.primary || colors.primary};
  text-indent: -9999em;
  margin: 110px auto;
  position: relative;
  font-size: 11px;
  transform: translateZ(0);
  animation-delay: -0.16s;

  &:before,
  &:after {
    background: ${props => props.theme.primary || colors.primary};
    animation: ${animations.load} 1s infinite ease-in-out;
    width: 1em;
    height: 4em;
    position: absolute;
    top: 0;
    content: '';
  }

  &:before {
    left: -1.5em;
    animation-delay: -0.32s;
  }

  &:after {
    left: 1.5em;
  }

  /* ✅ inline style-like override support */
  ${({ $customStyle }) =>
    $customStyle &&
    css`
      ${Object.entries($customStyle)
        .map(([key, value]) => `${key}: ${value};`)
        .join('\n')}
    `}
`

type Props = {
  error?: boolean,
  timedOut?: boolean,
  pastDelay?: number,
  tenant?: any
}

function Loader({ error, timedOut, pastDelay, tenant }: Props) {
  if (error) {
    return <div>Error!</div>
  } else if (timedOut) {
    return <div>Taking a long time...</div>
  } else if (pastDelay) {
    return <Bars theme={tenant && tenant.config.theme} />
  } else {
    return null
  }
}

export { Bars }
export default withTenant(Loader)
